module.exports = __webpack_public_path__ + "697eecec318431a773a98b9c711789a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_3-320.jpg
// module id = 587
// module chunks = 0